import { Company } from 'generated/apolloComponents'
import { useState } from 'react'
import TwitterContainer from '@/components/molecules/TwitterContainter'
import FacebookContainer from '@/components/molecules/FacebookContainter'

interface IProps {
  company: Company
  color?: string | ''
  title?: string | 'Sociale'
  className?: string
}

const SocialMediaPanel = ({ company, color, title, className }: IProps) => {
  const [active, setActive] = useState(
    company.facebook ? 'facebook' : company.twitter ? 'twitter' : null
  )
  return (
    <>
      {(company.facebook || company.twitter) && company.showMediaPanel && (
        <div
          id='socials'
          className='xs:w-full sm:w-108 bg-white rounded-xl xs:ml-0 md:ml-3 xs:mt-4 md:mt-0 xs:mb-4 md:mb-0 px-6 md:px-10 py-6 md:py-10'
        >
          <h2 className='text-2xl md:text-4xl font-medium'>{title}</h2>
          <div className='flex items-center mb-4 border-b-2'>
            <ul className='h-full justify-between flex flex-row text-center'>
              {company.facebook && (
                <li
                  key='facebook'
                  className={`flex-1 h-20 ${
                    active === 'facebook' ? 'active' : ''
                  }`}
                >
                  <button
                    type='button'
                    className='flex items-center justify-center font-medium text-xl pt-1 px-6 h-full border-b-4 border-transparent transition-colors hover:border-black'
                    style={{
                      marginBottom: '-1px',
                      borderColor:
                        active === 'facebook' ? color : 'transparent',
                    }}
                    onClick={() => setActive('facebook')}
                  >
                    <span
                      style={{ color: active === 'facebook' ? color : 'black' }}
                    >
                      Facebook
                    </span>
                  </button>
                </li>
              )}
              {company.twitter && (
                <li
                  key='twitter'
                  className={`flex-1 h-20 ${
                    active === 'twitter' ? 'active' : ''
                  }`}
                >
                  <button
                    type='button'
                    className='flex items-center justify-center font-medium text-xl pt-1 px-6 h-full border-b-4 border-transparent transition-colors hover:border-black'
                    style={{
                      marginBottom: '-1px',
                      borderColor: active === 'twitter' ? color : 'transparent',
                    }}
                    onClick={() => setActive('twitter')}
                  >
                    <span
                      style={{ color: active === 'twitter' ? color : 'black' }}
                    >
                      Twitter
                    </span>
                  </button>
                </li>
              )}
            </ul>
          </div>
          <div>
            {active === 'facebook' && <FacebookContainer company={company} />}
            {active === 'twitter' && <TwitterContainer company={company} />}
          </div>
        </div>
      )}
    </>
  )
}

export default SocialMediaPanel
